<template>
  <div class="row items-center">
    <router-link
      v-if="to"
      :to="to"
    >
      <q-btn
        :id="id"
        rounded
        dense
        color="primary"
        size="xl"
        icon="add"
      />
    </router-link>
    <q-btn
      v-else
      :id="id"
      rounded
      dense
      color="primary"
      size="xl"
      icon="add"
      @click="$emit('action-click')"
    />
    <p class="text-body1 text-grey-8 text-weight-bold q-pl-lg q-mb-none">
      {{ label }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: 'label' },
    to: { type: Object, default: null },
    id: { type: String, default: 'create-button' },
  },
};
</script>
